import { DefaultRequest } from './interfaces/default';

class CredentialsRequestParams {
  name: string;
  credentials: any;

  constructor(
    name: string,
    exchange: string,
    client_id: string,
    client_secret: string,
    passphrase?: string,
    testnet?: boolean,
  ) {
    this.name = name;

    const normalized = exchange.trim().toLowerCase();

    const credentialBuilders: Record<string, () => Record<string, unknown>> = {
      bullish: () => ({
        public_key: client_id,
        api_secret: client_secret,
      }),
      coincall: () => ({
        api_key: client_id,
        api_secret: client_secret,
      }),
      okx: () => ({
        api_key: client_id,
        secret_key: client_secret,
        passphrase: passphrase ?? '',
      }),
      binance: () => ({
        api_key: client_id,
        secret_key: client_secret,
        ...(testnet !== undefined ? { testnet } : {}),
      }),
    };

    const creds = credentialBuilders[normalized]?.() ?? {
      client_id: client_id,
      client_secret: client_secret,
    };

    this.credentials = {
      exchange: exchange,
      credentials: creds,
    };
  }
}

class CredentialsRequest implements DefaultRequest {
  jsonrpc: string;
  method: string;
  id: string | number;
  params: CredentialsRequestParams;

  constructor(
    id: string,
    name: string,
    exchange: string,
    client_id: string,
    client_secret: string,
    passphrase?: string,
    testnet?: boolean,
  ) {
    this.id = id;
    this.jsonrpc = '2.0';
    this.method = 'save_credentials';
    this.params = new CredentialsRequestParams(
      name,
      exchange,
      client_id,
      client_secret,
      passphrase,
      testnet,
    );
  }
}

class GetCredentialsRequest implements DefaultRequest {
  jsonrpc: string;
  method: string;
  id: string;
  params: object;

  constructor(id: string) {
    this.id = id;
    this.jsonrpc = '2.0';
    this.method = 'list_credentials';
    this.params = {};
  }
}

class DeleteCredentialsRequest implements DefaultRequest {
  jsonrpc: string;
  method: string;
  id: string;
  params: {
    name: string;
  };

  constructor(id: string, name: string) {
    this.id = id;
    this.jsonrpc = '2.0';
    this.method = 'delete_credentials';
    this.params = {
      name: name,
    };
  }
}

export {
  CredentialsRequest,
  CredentialsRequestParams,
  DeleteCredentialsRequest,
  GetCredentialsRequest,
};
